<template>
  <div>
    <page-title title="National Allergy Bureau" />
    <b-row>
      <b-col>
        <auth-form v-bind:mode.sync="mode" :defaultMode="defaultMode" @onAuthComplete="onAuthComplete"></auth-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Login",
  mixins: [],
  props: {},
  data() {
    return {
      defaultMode: 'login',
      mode: null
    };
  },
  methods: {
    onAuthComplete: function () {
      if (this.$route.query.redirect)
        this.$router.push(this.$route.query.redirect);
      else
        this.$router.push('/');
    }
  },
  mounted () {
    if (this.$root.$data.authenticatedUser.id && this.$root.$data.authenticatedUser.username.length > 0)
      this.onAuthComplete();
  }
};
</script>